module.exports = __webpack_public_path__ + "img/1B_old.2f4e8203.jpg";